/**
 * @package   ScandiPWA\GtmGraphQl
 * @author    Abdelrahman Hady <abdelrahman.hady@scandiweb.com>
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import Event, { EVENT_GTM_ADD_PAYMENT_INFO_GA4, EVENT_GTM_ADD_SHIPPING_INFO_GA4 } from '../../util/Event';

/** @namespace ScandiPWA/GtmGraphQl/Plugin/Event-dispatches/Plugin/onSubmitSuccess */
export const onSubmitSuccess = (args, callback, instance) => {
    const {
        selectedShippingMethod: { carrier_title: shipping_tier },
        selectedPaymentMethod: payment_type
    } = instance.state;

    Event.dispatch(EVENT_GTM_ADD_SHIPPING_INFO_GA4, { shipping_tier });
    Event.dispatch(EVENT_GTM_ADD_PAYMENT_INFO_GA4, { payment_type });

    return callback(...args);
};

export default {
    'Component/CheckoutShippingBilling/Container': {
        'member-function': {
            onSubmitSuccess
        }
    }
};
